import { Component, Input } from '@angular/core';
import {
    LoadingController,
	NavController,
    NavParams, 
    ToastController} from 'ionic-angular';
import { Organization } from '../../../../model/organization';
import { Rodeo } from '../../../../model/rodeo';
import { ReportsService } from '../../../../services/reports.service';
import { ActionSheetController } from 'ionic-angular';
import { Horse } from '../../../../model/horse';
import { HorseService } from '../../../../services/horse.service';
import { AlertMessager } from '../../../../lib/alertMessager';
import { E } from '@angular/core/src/render3';

@Component({
	selector: 'page-offspring-entry-report',
	templateUrl: 'report-offspring-entries.html'
	
})
export class OffspringEntryReport {
    @Input('organization') organization: Organization;

    selectedStallion: Horse;
    selectedRodeos: Rodeo[] = [];
    showContactInfo: boolean = false;

    documentTitle: any;

    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    offspringRodeos: Rodeo[] = [];

    constructor(
        private nav: NavController, 
        navParams: NavParams, 
        private loadingController: LoadingController,
        public actionSheetCtrl: ActionSheetController,
        public alert: AlertMessager,
        private horseService: HorseService
    ) {
        if (!this.organization)
            this.organization = navParams.get('organization');

        this.selectedStallion = navParams.get('selectedStallion');
        this.offspringRodeos = navParams.get('offspringRodeos');

        this.printing = navParams.get('printing');
    }

    ngAfterContentInit() {
        setTimeout(() => {
            this.load();
        }, 0);
    }

    load() {
        if (!this.selectedStallion && this.organization.nominations.length > 0)
            this.selectedStallion = this.organization.nominations[0].horseNominationSlots[0].horse;        

        if (!this.offspringRodeos)
            this.updateSelectedStallion();

        if (this.selectedStallion)
            this.documentTitle = this.selectedStallion.name + " - " + 'Offspring';
        
           this.dataLoaded = true;
    }

    async updateSelectedStallion() {     
        const loader = await this.loadingController.create({
            content: ("Loading offpsring entries for " + this.selectedStallion.name + "...")
        });

        await loader.present();

        try {
            const rodeos = await this.horseService.getNominatedHorseEntries(this.selectedStallion.id);
            loader.dismiss();

            if ((rodeos as any).message) {
                this.alert.showError('Offspring Entries Retrieval Failed', (rodeos as any).message);
            } else {
                this.offspringRodeos = rodeos;
                if (this.offspringRodeos.length > 0)
                    this.selectedRodeos = [this.offspringRodeos[0]];
            }
        } catch (err) {
            loader.dismiss();
            this.alert.showError('Offspring Entries Retrieval Failed', err && err.message ? err.message : 'Please try again later.');
        }
    }

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    ionViewDidEnter() {
        if (this.printing) {
            setTimeout(() => {
                window.document.title = this.documentTitle;
                window.print();
                this.nav.pop(); 
            }, 0);
        }
    }

    getHorseRole(registration) {
        let horse = registration.horseOne;

        if (!registration.horseTwoId)
            return "Horse";

        if (horse.sireId == this.selectedStallion.id) {
            return registration.teammateHeader ? 'Heeler' : 'Header';
        } else {
            return registration.teammateHeader ? 'Header' : 'Heeler';
        }
    }

    /*
    presentActionSheet() {
        const actionSheet = this.actionSheetCtrl.create({
          title: 'Select a report',
          buttons: [
            {
              text: '',
              handler: () => {
                if (this.selectedRodeoEvent) {
                    this.downloadEquistat(this.selectedRodeoEvent).then(() => {});
                } else {
                    this.toast.create({message: 'You must select an event.', position: 'bottom', duration: 2500}).present();
                }
              }
            },{
              text: 'QuickBooks Import',
              handler: () => {
                this.printQuickBooksImport();
              }
            },{
              text: 'Cancel',
              role: 'cancel'
            }
          ]
        });
        actionSheet.present();
    }
    */

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        
        this.nav.push(OffspringEntryReport, {
            organization: this.organization,
            printing: true,
            selectedStallion: this.selectedStallion,
            offspringRodeos: this.offspringRodeos,
            showContactInfo: this.showContactInfo
        }).then(() => { this.popoverActive = false; });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/reports/report-offspring-entries.ts